import React from "react";
import { Card } from "react-bootstrap";
import { _t, isEn, isJa } from "app/i18n/i18n";
import { FaIcon } from "lib/FaIcon";
import { HomeButton, InfoCard } from "pages/login/NotFound";

export const EmptyReadingList = () => (
  <InfoCard>
    <Card.Header>
      <h5>{_t("Your reading list is empty")}</h5>
    </Card.Header>

    <Card.Body>
      <figure className="text-center mb-3">
        <FaIcon icon="fas fa-inbox fa-4x text-gray text-center " />
      </figure>
      {isEn() && (
        <span>
          To add a publication: <br />
          1. Click <FaIcon icon="fas fa-ellipsis-v" /> next to a publication <br />
          2. Click <FaIcon icon="fa-fw fas fa-history fa-lg" /> <b>Add to Reading List</b> <br />
        </span>
      )}
      {isJa() && (
        <span>
          {_t("To add a publication: ")}
          <br />
          トップページで、リーディングリストに追加したいコンテンツのメニュー (<FaIcon icon="fas fa-ellipsis-v" />)
          をクリック。
          <br />
          メニューから、リーディングリストに追加(
          <FaIcon icon="fa-fw fas fa-history fa-lg" />
          )を選んでください。
          <br />
        </span>
      )}
    </Card.Body>

    <Card.Footer>
      <HomeButton />
    </Card.Footer>
  </InfoCard>
);
